import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 403 && error.response.data?.code === "site_locked") {
    window.dispatchEvent(new Event("site-locked"));
    // The app is swapped for the gate, so leave the call pending instead of surfacing unhandled rejections.
    return new Promise(() => {});
  }
  return Promise.reject(error);
});

// The session lives in an httpOnly cookie set by the server, so scripts never see the token.
// This counter only lets caches tell "signed in as someone else" apart from "same person".
let authEpoch = 0;

export function getAuthEpoch() {
  return authEpoch;
}

export function bumpAuthEpoch() {
  authEpoch += 1;
}

export function formatApiError(detail, fallback) {
  if (detail == null) return fallback || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMessage(e) {
  const status = e?.response?.status;
  const fallback = status >= 500 ? `The server had a problem (error ${status}). Please try again in a moment.` : null;
  return formatApiError(e?.response?.data?.detail, fallback) || e?.message || "Unknown error";
}

/** Uploaded media is stored as an origin relative /api/files path. */
export function mediaUrl(url) {
  if (!url) return url;
  return url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;
}

/** Every uploaded JPG has an 800px "-thumb" twin next to the 1600px original. */
export function thumbUrl(url) {
  if (url && url.startsWith("/api/files/") && url.endsWith(".jpg") && !url.endsWith("-thumb.jpg")) return `${url.slice(0, -4)}-thumb.jpg`;
  return url;
}

export const HERO_SIZES = "(max-width: 767px) 100vw, 1200px";

export function heroSrcSet(url) {
  const small = thumbUrl(url);
  return small && small !== url ? `${mediaUrl(small)} 800w, ${mediaUrl(url)} 1600w` : undefined;
}
